export const ActionTypes = {
  SET_DASHBOARD: "SET_DASHBOARD",
  SET_CUSTOMERS: "SET_CUSTOMRS",
  SET_ORDERS: "SET_ORDERS",
  SET_MENUS: "SET_MENUS",
  SET_USERS: "SET_USERS",
  UPDATE_USER: "UPDATE_USER",
  SET_TOKEN: "SET_TOKEN",
  SET_ACTIVE_USER: "SET_ACTIVE_USER",
  SET_COMPANY_INFO: "SET_COMPANY_INFO",
  SET_EMPLOYEES: "SET_EMPLOYEES",
  SET_STYLES: "SET_STYLES",
  SET_EMPLOYEE_TITLE: "SET_EMPLOYEE_TITLE",
  SET_IS_LOGIN: "SET_IS_LOGIN",
  SET_IS_CONNECTED: "SET_IS_CONNECTED",
};
